import { useQuery } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";

export interface StockValuationFilters {
  reportDate: string;
  layerDateFrom: string;
  layerDateTo: string;
}

export interface ValuationDetail {
  itemCode: string;
  description: string;
  broughtForward: number;
  totalIn: number;
  totalOut: number;
  balance: number;
  costPerQty: number;
  totalCost: number;
}

export interface CostLayer {
  purchaseDate: string;
  quantity: number;
  unitCost: number;
  layerValue: number;
}

export interface ItemCostLayer {
  itemCode: string;
  description: string;
  layers: CostLayer[];
  averageUnitCost: number;
  totalValue: number;
}

export interface StockValuationData {
  valuationDetails: ValuationDetail[];
  costLayers: ItemCostLayer[];
}

export const useStockValuation = (filters: StockValuationFilters) => {
  return useQuery<StockValuationData, Error>({
    queryKey: ["stockValuation", filters],
    queryFn: async () => {
      const params = new URLSearchParams({
        reportDate: filters.reportDate,
        layerDateFrom: filters.layerDateFrom,
        layerDateTo: filters.layerDateTo,
      });

      const response = await api.get<StockValuationData>(
        `/stock-valuation?${params.toString()}`
      );
      return response.data;
    },
  });
};
